<!-- <form [formGroup]="formGroup"> -->
<div class="checkboxes-modal-empty">
  <div mat-dialog-title>
    <h2>{{"sizes.Add Size" | translate}}</h2>
    <button mat-icon-button class="close" (click)="openConfirmDialog()">
      <mat-icon class="pop-close">close</mat-icon>
    </button>
  </div>

  <div *ngIf='dataLoading' class="dataLoading">
    <mat-spinner class="m-auto" diameter="50"></mat-spinner>
  </div>
  <ng-container *ngIf='!dataLoading'>
    <div class="modal-subhead">
      <div class="row">
        <div class="col-12 d-block m-auto">

            <div class="form-group">
              <div class="input-group search-control">
                <div class="input-group-prepend">
                  <button class="input-group-text" type="button">
                    <img src="./assets/images/icons/search.svg" alt="">
                  </button>
                </div>
                <input type="text" maxlength="20"
                  class="form-control font-14"
                  [(ngModel)]="searchText"
                  [placeholder]="'forms.Search for sizes' | translate"
                  (keyup.enter)="getAll()">
              </div>
            </div>
        </div>
      </div>
    </div>
    <mat-dialog-content class="pt-1 checkboxes-modal" *ngIf="hasRecordsData() else dataEmpty">
      <div class="mat-dialog-body">

        <ng-container *ngFor="let item of sizes; let i = index">
          <div [hidden]="searchText && hideOption(item)">
            <mat-checkbox class="p-2" [(ngModel)]="item.isSelected" [hidden]="!item.canSelect" [class.d-block]="item.canSelect"
              (change)="selected($event, item)">
              <div class="name-with-image squared ml-3">
                <div class="image-circle">
                  <!-- <img [src]="item.icon" alt=""> -->
                  <span>{{ item.name | shortName }}</span>
                </div>
                <div class="name">
                  <h5 class="font-16">{{item.name}}</h5>
                </div>
              </div>
            </mat-checkbox>
          </div>

        </ng-container>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button class="btn-grey" (click)="openConfirmDialog()">{{"forms.Cancel" | translate}}</button>


      <button (click)="saveRecord()" mat-raised-button color="primary" [disabled]="dataLoading"
        [class.loading]="dataLoading">
        {{"forms.Submit" | translate}}
      </button>

    </mat-dialog-actions>

    <ng-template #dataEmpty>
      <empty-state [title]='"general.No Data Found" | translate'></empty-state>
    </ng-template>
  </ng-container>
</div>
  <!-- </form> -->
